<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-calendar"></i> 生产管理
        </el-breadcrumb-item>
        <el-breadcrumb-item>工厂列表</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="handle-box">
        <el-form ref="searchform" :model="searchform" label-width="90px" @keyup.enter.native="search()">
          <el-row>
            <el-col :span="6">
              <el-form-item label="工厂编号" prop="factoryCode">
                <el-input v-model="searchform.factoryCode" style="width:100%" clearable placeholder="请输入工厂编号" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="工厂类别" prop="factoryType">
                <el-select v-model="searchform.factoryType" style="width:100%" placeholder="请选择工厂类别">
                  <el-option v-for="(item, index) in searchfactory_type" :key="index" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="16" style="margin-left:10px">
              <el-button type="primary" icon="el-icon-search" @click="search" v-permission="['plantlist_select']">搜索
              </el-button>
              <el-button @click="resetForm('searchform')">重置</el-button>
              <el-button type="primary" icon="el-icon-plus" @click="addplant()" v-permission="['plantlist_add']">新建工厂
              </el-button>
              <el-button v-permission="['plantlist_export']" :loading="downloadLoading" type="primary" icon="document"
                @click="handleDownload">导出Excel</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <el-divider></el-divider>
      <el-row type="flex" class="row-bg">
        <el-col :span="24">
          <el-table v-loading="listLoading" element-loading-text="拼命加载中" :data="tableData" border style="width:100%"
            @cell-click="danhang">
            <el-table-column prop="factory_code" label="工厂编号"></el-table-column>
            <el-table-column prop="factory_name" label="工厂名称" show-overflow-tooltip></el-table-column>
            <el-table-column prop="factory_type_name" label="工厂类别"></el-table-column>
            <el-table-column prop="factory_address" label="地址" show-overflow-tooltip></el-table-column>
            <el-table-column prop="relation_depart_code" label="关联部门编码" show-overflow-tooltip></el-table-column>
            <el-table-column prop="action" label="操作" min-width="130">
              <template slot-scope="props">
                <el-button-group>
                  <el-button type="primary" plain size="mini" @click="update(props.row)"
                    v-permission="['plantlist_update']">修改
                  </el-button>
                  <el-button type="danger" plain size="mini" @click="deletedata(props.row)"
                    v-permission="['plantlist_delete']">删除
                  </el-button>
                  <el-button type="primary" plain size="mini" @click="tiaozhuan(props.row)"
                    v-permission="['plantlist_link']">车间列表
                  </el-button>
                </el-button-group>
              </template>

            </el-table-column>
          </el-table>
          <br />
          <!-- 新增弹出框 -->
          <el-dialog :title="title" :visible.sync="dialogVisible" width="28%" :modal="true" center>
            <el-form :model="form" :rules="rules" ref="form" label-width="100px" style="margin-left:15%">
              <el-row>
                <el-form-item label="工厂编号" prop="factory_code">
                  <el-input v-model="form.factory_code" style="width:80%" placeholder="请输入工厂编号" />
                </el-form-item>
                <el-form-item label="工厂名称" prop="factory_name">
                  <el-input v-model="form.factory_name" style="width:80%" placeholder="请输入工厂名称" />
                </el-form-item>

                <el-form-item label="部门">
                  <el-select v-model="form.relation_depart_code" placeholder="请输入名称模糊匹配下拉选择" style="width: 80%"
                    :remote-method="getdepartlist" filterable remote>
                    <el-option v-for="item in relation_depart_codelist" :key="item.depart_code"
                      :label="item.depart_name" :value="item.depart_code" />
                  </el-select>
                </el-form-item>
                <el-form-item label="工厂类别" prop="factory_type">
                  <el-select v-model.number="form.factory_type" style="width:80%" placeholder="请选择工厂类别">
                    <el-option v-for="item in factory_type" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="地址" prop="factory_address">
                  <el-input v-model="form.factory_address" style="width:80%" placeholder="请输入地址" />
                </el-form-item>
              </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="dialogVisible = false">取 消</el-button>
              <el-button @click="resetForm('form')">重置</el-button>
              <el-button type="primary" @click="submitadd('form')">确 定</el-button>
            </span>
          </el-dialog>
          <el-pagination background @current-change="currentchange" @size-change="pagesize"
            :current-page.sync="currentPage" :page-sizes="[10, 20, 50, 100]"
            layout="total,prev, pager, next,jumper,sizes" :total="total_count"></el-pagination>
          <el-divider></el-divider>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import {
  factorylist,
  factoryadd,
  factorydelete,
  factoryupdate
} from "@/api/plant";
import { depart30list } from "@/api/orgin";
import { construct, destruct } from "@aximario/json-tree";
//引入导出组件模块
export default {
  mounted() {
    //请求部门列表数据并且便利到表格
    this.Tabledata();
    this.getdepartlist();
  },
  data() {
    return {
      // 下拉数据
      factory_type: [
        {
          value: 0,
          label: "自有工厂"
        },
        {
          value: 1,
          label: "外协工厂"
        }
      ],
      searchfactory_type: [
        {
          value: 0,
          label: "自有工厂"
        },
        {
          value: 1,
          label: "外协工厂"
        }
      ],
      //基础数据
      dialogVisible: false,
      title: '新建工厂',
      tableData: [],
      factorysublist: [],
      relation_depart_codelist: [],
      departtree: null,
      //分页数据
      pagesizes: "",
      total_count: 1,
      currentPage: 1,
      //搜索表单数据
      searchform: {
        factory_uuid: null,
        factoryName: null,
        factoryCode: null,
        factoryType: null,
        factory_address: null
      },
      //导出表格变量
      tableDataDownload: [],
      listLoading: true,
      downloadLoading: false,
      filename: "",
      autoWidth: true,
      bookType: "xlsx",
      //修改表单数据
      //新增弹窗变量begin
      //表单数据
      form: {
        factory_uuid: "",
        factory_name: "",
        factory_code: "",
        factory_type: "",
        factory_address: "",
        relation_depart_code: ''
      },
      //基础表单验证
      rules: {
        relation_depart_code: [
          { required: true, message: "请选择关联部门编码", trigger: "blur" }
        ],
        factory_name: [
          { required: true, message: "请输入工厂名称", trigger: "blur" }
        ],
        factory_code: [
          { required: true, message: "请输入工厂编号", trigger: "blur" },
          // { validator: this.ifbianma, trigger: "blur" },
          { validator: this.$validateaccount, trigger: "blur" }
        ],
        factory_type: [
          { required: true, message: "请选择工厂类别", trigger: "change" }
        ],
        factory_address: [
          { required: true, message: "请输入工厂地址", trigger: "change" }
        ]
      }
    };
  },
  methods: {
    // 验证编码方法
    ifbianma(rule, value, callback) {
      if (this.dialogVisible) {
        factorylist({ factoryCode: value }).then(response => {
          if (response.data.data.length >= 1) {
            callback(new Error("编码不能重复"));
          } else {
            callback();
          }
        });
      } else {
        callback();
      }
    },
    //请求表格数据
    Tabledata(obj) {
      this.listLoading = true;
      factorylist(obj).then(response => {
        this.tableData = response.data.data;
        for (let i = 0; i < this.tableData.length; i++) {
          switch (this.tableData[i].factory_type) {
            case 0:
              this.tableData[i].factory_type_name = "自有工厂";
              break;
            case 1:
              this.tableData[i].factory_type_name = "外协工厂";
              break;
            default:
              break;
          }
        }
        this.total_count = response.data.total_count;
        this.currentPage = response.data.page_index;
        this.listLoading = false;
        console.log(this.tableData);
      });
    },
    //新增保存提示
    submitadd(formName) {
      this.$refs[formName].validate(valid => {
        //基础表单验证
        if (valid) {
          this.dialogVisible = false;
          if (this.title == '新建工厂') {
            factoryadd(this.form).then(response => {
              if (response.status_code == 200) {
                this.$message({
                  type: "success",
                  message: "添加成功!"
                });
                this.resetForm(formName);
                this.Tabledata();
                console.log(this.form.account_status);
              } else {
                this.$message({
                  type: "warning",
                  message: "添加失败!请检查字段"
                });
              }
            });
          } else {
            factoryupdate(this.form).then(response => {
              if (response.status_code == 200) {
                this.$message({
                  type: "success",
                  message: "修改成功!"
                });
                this.currentchange(this.currentPage);
              } else {
                this.$message({
                  type: "woring",
                  message: "修改失败!请检查字段"
                });
              }
            });
          }

        } else {
          return false;
        }
      });
    },
    //搜索事件
    search() {
      this.Tabledata(this.searchform);
    },
    //重置按钮
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    //分页跳转事件
    currentchange(pageIndex) {
      this.currentPage = pageIndex;
      this.Tabledata({
        factory_uuid: this.searchform.factory_uuid,
        factoryName: this.searchform.factoryName,
        factoryCode: this.searchform.factoryCode,
        factoryType: this.searchform.factoryType,
        factory_address: this.searchform.factory_address,
        pageIndex: this.currentPage
      });
    },
    //分页每页显示条数事件
    pagesize(pageSize) {
      this.Tabledata({ pageSize });
    },
    //表格单行点击
    danhang(row) {
    },
    addplant() {
      this.title = '新建工厂';
      this.dialogVisible = true
    },
    // 修改按钮弹窗
    update(row) {
      this.title = '修改工厂';
      this.form = Object.assign({}, row)
      this.dialogVisible = true; //弹窗false关闭 true开启
    },
    //删除按钮事件
    deletedata(row) {
      this.$confirm("此操作将永久删除该工厂信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          factorydelete({
            factory_uuid: row.factory_uuid
          }).then(response => {
            if (response.status_code == 200) {
              this.$message({
                type: "success",
                message: "删除成功!"
              });
              this.Tabledata();
            } else {
              this.$message({
                type: "woring",
                message: "删除失败!请检查字段"
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    //导出表格事件
    handleDownload() {
      this.downloadLoading = true;
      const obj = {
        page_index: 1,
        pageSize: this.total_count,
        factory_uuid: this.searchform.factory_uuid,
        factoryName: this.searchform.factoryName,
        factoryCode: this.searchform.factoryCode,
        factoryType: this.searchform.factoryType,
        factory_address: this.searchform.factory_address
      };
      factorylist(obj).then(response => {
        this.tableDataDownload = response.data.data;
        for (let i = 0; i < this.tableDataDownload.length; i++) {
          switch (this.tableDataDownload[i].factory_type) {
            case 0:
              this.tableDataDownload[i].factory_type_name = "自有工厂";
              break;
            case 1:
              this.tableDataDownload[i].factory_type_name = "外协工厂";
              break;
            default:
              break;
          }
        }

        console.log(this.tableDataDownload);
        import("@/vendor/Export2Excel").then(excel => {
          const tHeader = [
            "工厂编号",
            "工厂名称",
            "工厂类别",
            "地址"
          ];
          const filterVal = [
            "factory_code",
            "factory_name",
            "factory_type_name",
            "factory_address"
          ];
          const list = this.tableDataDownload;
          const data = this.formatJson(filterVal, list);
          excel.export_json_to_excel({
            header: tHeader,
            data,
            filename: this.filename,
            autoWidth: this.autoWidth,
            bookType: this.bookType
          });
          this.downloadLoading = false;
        });
      }); // hear
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v =>
        filterVal.map(j => {
          if (j === "timestamp") {
            return parseTime(v[j]);
          } else {
            return v[j];
          }
        })
      );
    },
    //跳转页面
    tiaozhuan(row) {
      setTimeout(() => {
        this.$route.query.factory_code = row.factory_code;
        this.$router.push({
          path: "/workshoplist",
          query: { factory_code: row.factory_code }
        });
      }, 100);
    },
    getdepartlist(value) {
      if (value !== "") {
        setTimeout(() => {
          this.relation_depart_codelist = [];
          depart30list({
            pageIndex: 1,
            pageSize: 10,
            depart_code: '',
            depart_name: value,
            // status: -1,
            // depart_level: -1,
          }).then(response => {
            this.relation_depart_codelist = response.data.listItems;
          });
        }, 200);
      } else {
        this.relation_depart_codelist = [];
      }
    },
  }
};
</script>
<style scoped></style>
